module.exports = __webpack_public_path__ + "static/media/KDAA1_2.dc78d15c.png";